import i18n from '@/utils/i18n';
import React from 'react';
import { StatusLabel } from './status-label';
import { StyleProp, ViewStyle } from 'react-native';
import { VariantPackAvailabilityStatus } from '@/enums';

interface Props {
  availabilityStatus: VariantPackAvailabilityStatus | null;
  compact?: boolean;
  containerStyle?: StyleProp<ViewStyle>;
}

interface LabelProperties {
  displayText: string;
  isError: boolean;
}

const getLabelProperties = (
  availabilityStatus: VariantPackAvailabilityStatus | null,
): LabelProperties => {
  switch (availabilityStatus) {
    case VariantPackAvailabilityStatus.OUT_OF_STOCK:
      return {
        displayText: i18n.t('availability_status.out_of_stock'),
        isError: false,
      };
    case VariantPackAvailabilityStatus.DISCONTINUED:
      return {
        displayText: i18n.t('availability_status.discontinued'),
        isError: true,
      };
    case VariantPackAvailabilityStatus.SPECIAL_ORDER:
      return {
        displayText: i18n.t('availability_status.special_order'),
        isError: false,
      };
    case VariantPackAvailabilityStatus.LOW_STOCK:
      return {
        displayText: i18n.t('availability_status.low_stock'),
        isError: false,
      };
    default:
      // Fallback if no status set, or status is not recognized on the client
      return {
        displayText: i18n.t('unavailable'),
        isError: true,
      };
  }
};

export const AvailabilityStatusLabel: React.FC<Props> = ({
  availabilityStatus,
  compact,
  containerStyle,
}) => {
  const { displayText, isError } = getLabelProperties(availabilityStatus);

  return (
    <StatusLabel
      compact={compact}
      containerStyle={containerStyle}
      isError={isError}
      testID="availability-status-label"
      text={displayText}
    />
  );
};
